import vuetify from '@/plugins/vuetify';
import i18n from '@/plugins/i18n';
import { LocalKeys } from '@/types/misc';
import { Route } from 'vue-router';
import { VueRouter } from 'vue-router/types/router';


const direction = {
  ar: 'rtl',
  en: 'ltr',
};

const applyLanguageSettings = (locale: LocalKeys) => {
  i18n.locale = locale;
  vuetify.framework.rtl = locale === 'ar';
  document.documentElement.setAttribute('dir', direction[locale]);
  localStorage.setItem('language', locale);
};

const getLocaleFromRoute = (route?: Route): LocalKeys | null => {
  if (!route?.query?.lang) return null;

  const langParam = route.query.lang as string;
  return (langParam === 'ar' || langParam === 'en') ? langParam as LocalKeys : null;
};

// Helper function to update URL with locale using Vue Router
const updateUrlWithLocale = (locale: LocalKeys, route: Route, router: VueRouter) => {
  if (!route.query.lang) return; // Only update if lang param already exists
  const notLangQueryParams = route.query;
  router.replace({
    query: {
      ...notLangQueryParams,
      lang: locale,
    }
  }).catch(() => {
  }); // Catch navigation duplicated error
};
export const toggleLanguage = (route: Route, router: VueRouter) => {
  const locale = i18n.availableLocales.find(innerLocale => innerLocale !== i18n.locale) as LocalKeys;
  applyLanguageSettings(locale);
  updateUrlWithLocale(locale, route, router);
};

export const initializeLanguageAndDirection = (route: Route) => {
  const urlLocale = getLocaleFromRoute(route);
  const defaultLanguage = process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'ar';
  const savedLanguage = (localStorage.getItem('language') || defaultLanguage) as LocalKeys;
  const finalLocale = urlLocale || savedLanguage || defaultLanguage;

  applyLanguageSettings(finalLocale as LocalKeys);

  // If URL had locale but localStorage was different, update localStorage
  if (urlLocale && urlLocale !== savedLanguage) {
    localStorage.setItem('language', urlLocale);
  }
};
